import React from 'react';

function EscortServicesDetails() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-6">
      <h1 className="text-4xl font-bold mb-8 text-center">Escort Services UK</h1>
      <div className="bg-gray-900 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-200">
        <h2 className="text-3xl font-semibold mb-4 text-white">Overview</h2>
        <p className="text-white mb-4">
          Our escort services in the UK ensure safe and secure transportation for individuals and valuable assets. We provide professional and discreet escort services tailored to meet your specific needs, ensuring peace of mind throughout the journey.
        </p>
        <h2 className="text-2xl font-semibold mb-4 text-white">Services We Offer</h2>
        <ul className="list-disc list-inside text-white space-y-2">
          <li>Personal Escort Services</li>
          <li>Executive Protection</li>
          <li>Asset Protection and Transport</li>
          <li>VIP and Celebrity Escort</li>
          <li>Event Security Escort</li>
          <li>Secure Transportation</li>
        </ul>
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-white">Why Choose Us?</h2>
        <p className="text-white mb-4">
          Our team of experienced escort professionals in the UK is dedicated to providing high-quality and reliable escort services. We prioritize your safety and confidentiality, using the latest security measures and protocols to ensure a secure experience.
        </p>
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-white">Contact Us</h2>
        <p className="text-white">
          For more information about our escort services in the UK, please contact us at <a href="tel:07460395006" className="text-yellow-500 hover:underline">0746 039 5006</a> or email us at <a href="mailto:info@crowndefencesecurity.co.uk" className="text-yellow-500 hover:underline">info@crowndefencesecurity.co.uk</a>.
        </p>
      </div>
    </div>
  );
}

export default EscortServicesDetails;
